import OAutocomplete from '../../../UI/MuiAutocomplete';
import { useTranslation } from 'react-i18next';
import styles from './MachineForm.module.css';

const MachineForm = ({
  machineValue,
  machineData,
  contactValue,
  generalValue,
  machineType,
}) => {
  const { t, i18n } = useTranslation();
  const handleClickMachine = (e) => {
    machineValue((curr) => {
      return { ...curr, nazivMasine: e.vrednost, idMasine: e.id };
    });
  };
  return (
    <div className={styles.formContainer}>
      <div className={styles.machineContainer}>
        <OAutocomplete
          data={machineData}
          value={machineValue.nazivMasine}
          handleClick={handleClickMachine}
          label={`${
            machineType === ''
              ? ''
              : machineType === 'Robot'
              ? t('Robot')
              : t('Alat')
          }`}
          style={{ width: '100%' }}
          disabled
        />
      </div>
      <div className={styles.contactContainer}>
        <strong className={styles.title}>{t('contactPerson')}</strong>
        <label
          style={{ fontWeight: 'bold' }}
        >{`${contactValue.kontaktOsoba}`}</label>
        <label>
          <i style={{ marginRight: '10px' }} className="fas fa-phone-alt" />
          {`${contactValue.telefon}`}
        </label>
        <label>
          <i style={{ marginRight: '10px' }} className="fas fa-envelope" />
          {`${contactValue.email}`}
        </label>
      </div>
      <div className={styles.statusContainer}>
        <span
          style={{
            fontWeight: 'bold',
            color: generalValue.poslato ? 'green' : 'red',
          }}
        >
          {generalValue.poslato
            ? t('requestStatuses.sent')?.toUpperCase()
            : t('requestStatuses.inPreparation')?.toUpperCase()}
        </span>
      </div>
    </div>
  );
};

export default MachineForm;
